'use client'
/* eslint-disable react/jsx-no-literals */
import React from 'react'
import Link from 'next/link'

import {
  CategoryCard,
  CategoryImage,
  CategoryImageStyled,
  CategoryName,
} from '.'
import { noImagUrl } from '../../../../utils/constants'

const TAG = 'TAG'

const AllCategoryCard = ({ grid, item, shape }) => {
  const type = item.entityType === TAG ? 'tag' : 'category'

  return (
    <Link
      as={`/${type}/${item.slug}`}
      href={`/${type}/[${type}Name]`}
      passHref
      key={item.id}
      legacyBehavior
      prefetch={true}
    >
      <CategoryCard grid={grid} data-test="item">
        <CategoryImage>
          <CategoryImageStyled
            src={item.image || noImagUrl}
            alt={item.name}
          ></CategoryImageStyled>
        </CategoryImage>
        <CategoryName shape={shape}>{item.name}</CategoryName>
      </CategoryCard>
    </Link>
  )
}

export default AllCategoryCard
